const EMPTY_EDITOR_HTML = '<p><br></p>';

const appendImageHtml = (currentHtml: string, imageSrc: string) => {
  const stickerHtml = `<p><img src="${imageSrc}"></p>`;
  if (!currentHtml || currentHtml === EMPTY_EDITOR_HTML) {
    return stickerHtml;
  }

  return `${currentHtml}${stickerHtml}`;
};

const blurActiveElement = () => {
  const activeElement = document.activeElement as HTMLElement | null;
  activeElement?.blur?.();
};

export const insertStickerIntoRichTextEditor = (
  editorRef: any,
  imageSrc: string,
  currentHtml: string,
  setHtml: (nextHtml: string) => void
) => {
  const scrollX = window.scrollX;
  const scrollY = window.scrollY;
  const editor = editorRef?.current?.getEditor?.();

  if (!editor) {
    setHtml(appendImageHtml(currentHtml, imageSrc));
    return;
  }

  const range = editor.getSelection?.();
  const position = range ? range.index : Math.max(editor.getLength?.() - 1 || 0, 0);

  editor.insertEmbed(position, 'image', imageSrc);

  const editorHtml = editor.root?.innerHTML || '';
  setHtml(
    editorHtml.includes(imageSrc)
      ? editorHtml
      : appendImageHtml(currentHtml, imageSrc)
  );

  editor.blur?.();
  blurActiveElement();
  window.scrollTo(scrollX, scrollY);
  requestAnimationFrame(() => {
    editor.blur?.();
    blurActiveElement();
    window.scrollTo(scrollX, scrollY);
  });
};
